var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "kaka-container" }, [
    _c("div", { staticClass: "kaka-back", on: { click: _vm.goBack } }, [
      _c("i", { staticClass: "el-icon-arrow-left" })
    ]),
    _vm._v(" "),
    _c("iframe", {
      ref: "kakaFrame",
      staticClass: "kaka-iframe",
      attrs: { src: _vm.iframeSrc, allow: "clipboard-read; clipboard-write" },
      on: { load: _vm.onIframeLoad }
    })
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-66f3c76e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-66f3c76e","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/Kaka/Index.vue
// module id = null
// module chunks = 